import { useParams } from "react-router"
import { Knot, useAddKnot, useKnots, useNode } from "../utils/query"
import { useEffect, useState, useRef, useCallback } from "react"
import NodeTimeline from "../components/NodeTimeline"
import NodeProfileCard from "../components/NodeProfileCard"
import { useTranslation } from "react-i18next"
import { generateKnots } from "../utils/utils"



const Node = () => {
  const { t } = useTranslation(['common']);

  let params = useParams()

  const clickGenerateKnots = async () => {
    if (params.id) {
      const knots = generateKnots(params.id, 1000);
      for (const knot of knots) {
        await addKnot(knot);
      }
    }
  }

  const [node, setNode] = useState<any>(null)
  const [knots, setKnots] = useState<Knot[]>([]);


  const nodeQuery = useNode(params.id ?? '');


  useEffect(() => {
    if (nodeQuery.data) {
      setNode({
        emails: [],
        phoneNumbers: [],
        socialMediaLinks: [],
        ...nodeQuery.data
      })
    }
  }, [nodeQuery.data])

  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
  } = useKnots({ nodeId: params.id ?? '', searchParam: '' });


  useEffect(() => {
    if (data) {
      setKnots(prev => [...data.pages.flatMap(page => page.data)]);
    }
  }, [data]);

  const observer = useRef<IntersectionObserver>();

  const lastElementRef = useCallback((node: HTMLElement | null) => {
    if (isLoading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasNextPage) {
        fetchNextPage();
      }
    });

    if (node) observer.current.observe(node);
  }, [isLoading, fetchNextPage, hasNextPage]);

  const mutation = useAddKnot();


  const addKnot = async (newKnot: Knot) => {
    await mutation.mutate(newKnot)
    //TODO: Then invalidate the query
    return;
  }

  console.log('node', node)
  return (
    <div className="max-w-3xl mx-auto">
      <button className="btn btn-primary" onClick={clickGenerateKnots}>Generate Knots</button>
      <NodeProfileCard data={node} />
      <div role="tablist" className="tabs tabs-lifted">
        <input type="radio" name="my_tabs_2" role="tab" className="tab" aria-label="Knots" defaultChecked />
        <div role="tabpanel" className="tab-content bg-base-100 border-base-300 rounded-box p-6">
          <NodeTimeline nodeId={params.id ?? ''} knots={knots} lastElementRef={lastElementRef} addKnot={addKnot} />
        </div>

        <input
          type="radio"
          name="my_tabs_2"
          role="tab"
          className="tab"
          aria-label="Data"
        />
        <div role="tabpanel" className="tab-content bg-base-100 border-base-300 rounded-box p-6">
          {t('test content')} Tab content 2
        </div>
      </div>

    </div>
  )
}

export default Node